/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { ErrorSection } from "@cosmos/components";
import { reportClientErrorAsync } from "@cosmos/next-common";
import { useEffect } from "react";

export default function Error({ error }: { error: Error & { digest?: string }; reset: () => void }): React.JSX.Element {
	useEffect(() => {
		console.error(error);
		const errorWithContext = {
			...error,
			errorBoundary: "page-level",
			message: error.message,
			stack: error.stack,
			cause: error.cause,
			digest: error.digest,
			name: error.name,
		};
		void reportClientErrorAsync(errorWithContext);
	}, [error]);

	return <ErrorSection statusCode={500} />;
}
